module.exports = __webpack_public_path__ + "static/Sonyax46-f895b1e07d718d95aaac15035d09d728.png";